import invite from './create/inviteText.js';
import create from './create/text.js';

export default {
  create,
  invite,
  header: {
    notes: 'Header when listing user',
    message: 'Users',
  },
  role: {
    header: {
      notes: 'Header for roles section for user',
      message: 'Roles',
    },
    name: {
      notes: 'Role name when listing roles applicable for user',
      message: 'Role',
    },
    in: {
      notes: 'Company / region where role is applicable for user',
      message: 'In',
    },
  },
  notification: {
    header: {
      notes: 'Header for notification section for user',
      message: 'Notifications',
    },
    passwordChanged: {
      notes: 'A message when admin changed a password for a user',
      message: 'The password was changed',
    },
  },
  userAccount: {
    header: {
      notes: 'Header for user account section for user',
      message: 'User account',
    },
    password: {
      notes: 'Label of password field in read-only mode',
      message: 'Password',
    },
  },
  action: {
    activate: {
      notes: 'Activate user action',
      message: 'Activate',
    },
    inactivate: {
      notes: 'Inactivate user action',
      message: 'Inactivate',
    },
    remove: {
      notes: 'Remove user action',
      message: 'Remove',
    },
    activationComplete: {
      notes: 'Message shown when user has been activated',
      message: 'User activated successfully',
    },
    inactivationComplete: {
      notes: 'Message shown when user has been inactivated',
      message: 'User inactivated successfully',
    },
    removeComplete: {
      notes: 'Message shown when user has been removed (soft deleted)',
      message: '{{username}} has been successfully removed.',
    },
  },
  confirmInactivation: {
    header: {
      notes: 'Confirm inactivation dialog title',
      message: 'Inactivate user',
    },
    content: {
      notes: 'Contents of inactivate user dialog',
      message:
        "Are you sure you want to inactivate user {{username}}? They will lose access to SAM immediately. You will be able to activate them whenever you'd like to.",
    },
  },
  confirmRemove: {
    header: {
      notes: 'Confirm remove user dialog title',
      message: 'Remove user',
    },
    content: {
      notes: 'Contents of remove user dialog',
      message:
        'Are you sure you want to remove {{username}}? This action cannot be undone.',
    },
    magicWordInstruction: {
      notes: 'Instruction for how to enter a specific word to enable delete.',
      message: 'If you are sure, please type {{magicWord}} below.',
    },
    magicWord: {
      notes: 'Specific word used for confirm.',
      message: 'Remove',
    },
  },
  model: {
    username: {
      notes: 'User name field for user',
      message: 'Username',
    },
    firstName: {
      notes: 'First name field for user',
      message: 'First name',
    },
    lastName: {
      notes: 'Family name field for user',
      message: 'Family name',
    },
    email: {
      notes: 'E-mail field for user',
      message: 'E-mail',
    },
    avatar: {
      notes: 'Avatar field for user',
      message: 'Avatar',
    },
    company: {
      notes: 'Company field for user',
      message: 'Company',
    },
    site: {
      notes: 'Site field for user',
      message: 'Site',
    },
    password: {
      notes: 'Password field for user',
      message: 'New password',
      validation: {
        minLength: {
          notes:
            'Validation message when minimum length requirement of password is not met',
          message:
            'The password needs to be a minimum of {{minLength}} characters',
        },
        notUsername: {
          notes: 'Validation message when username is entered as new password',
          message: 'The username may not be used as password',
        },
        notEmail: {
          notes: 'Validation message when email is entered as new password',
          message: 'The e-mail may not be used as password',
        },
        notMatching: {
          notes:
            'Validation message when password and retyped password is not matching',
          message: 'Passwords does not match',
        },
      },
    },
    retypePassword: {
      notes: 'Retype password when changing password',
      message: 'Confirm new password',
    },
    currentPassword: {
      notes: 'Current password the user have',
      message: 'Current password',
    },
    passwordResetAt: {
      notes: 'Last password reset for user',
      message: 'Last password reset',
    },
    passwordChanged: {
      notes: 'A message to the user when the password was changed',
      message: 'Your password was changed',
    },
    passwordNotChanged: {
      notes: 'The password could not be changed.',
      message: 'Your password could not be changed',
    },
    passwordExpiry: {
      notes: 'Password expiry for user',
      message: 'Password expiry',
    },
    status: {
      notes: 'Status field for user',
      message: 'Status',
      values: {
        invited: {
          notes: 'Status "invited" for user',
          message: 'Invited',
        },
        active: {
          notes: 'Status "active" for user',
          message: 'Active',
        },
        suspended: {
          notes: 'Status "inactive" for user',
          message: 'Inactive',
        },
        removed: {
          notes: 'Status "removed" for user',
          message: 'Removed',
        },
      },
    },
    acceptedAt: {
      notes: 'Accepted at field for user',
      message: 'Accepted at',
    },
    emailNotifications: {
      notes: 'E-mail notifications field for user',
      message: 'E-mail notifications',
    },
    pushNotifications: {
      notes: 'Push notifications field for user',
      message: 'Push notifications',
    },
    smsNotifications: {
      notes: 'SMS notifications field for user',
      message: 'SMS notifications',
    },
    recoveryEmail: {
      notes: 'Recovery e-mail field for user',
      message: 'Recovery e-mail',
    },
    recoveryPhone: {
      notes: 'Recovery phone field for user',
      message: 'Recovery phone',
    },
  },
};
